<template>
  <div>
    <base-button
      id="tooltip-help-video"
      inverse
      block
      class="d-flex justify-content-between align-items-center px-3"
      :data-html="true"
      title="Puedes acceder a un video explicativo"
      @click="show = true"
      @mouseover="tooltipToggle(true)"
      @mouseleave="tooltipToggle(false)"
    >
      Ver ayuda<fa-icon icon="info-circle" />
    </base-button>
    <base-modal
      :id="'HelpChartVideo'+src"
      title="¿Necesitas ayuda?"
      :show="show"
      :size="calculatedSize"
      @closed="close"
    >
      <video-player
        ref="videoPlayer"
        class="video-player-box"
        :options="playerOptions"
      />
      <template slot="footer">
        <base-button
          inverse
          @click="close"
        >
          Cerrar
        </base-button>
      </template>
    </base-modal>
  </div>
</template>

<script>
import $ from 'jquery';

/* eslint-disable import/no-extraneous-dependencies */
import 'video.js/dist/video-js.css';
import { videoPlayer } from 'vue-video-player';

export default {
    name: 'HelpChartVideo',
    components: {
        videoPlayer,
    },
    props: {
        src: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            show: false,
            playerOptions: {
                fluid: true,
                controls: true,
                autoplay: false,
                sources: [
                    {
                        type: 'video/mp4',
                        src: `vid/${this.src}.mp4`,
                    },
                ],
            },
        };
    },
    computed: {
        player() {
            return this.$refs.videoPlayer.player;
        },
        calculatedSize() {
            const height = window.innerHeight;
            if (height > 700) {
                return 'modal-xl';
            }
            return 'modal-lg';
        },
    },
    methods: {
        close() {
            this.player.pause();
            this.show = false;
        },
        tooltipToggle(on) {
            if (on) {
                $('#tooltip-help-video').tooltip('show');
            } else {
                $('#tooltip-help-video').tooltip('hide');
            }
        },
    },
};
</script>

<style lang="scss" scoped>
</style>
